import { ReduxState, Vehicle } from 'types';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import * as vehiclesActions from 'features/vehicles/vehiclesActions';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import { LicensePlatePermission, ModalEnum, ThemeColor } from 'myParkdUtils/enums';
import { FormattedMessage } from 'react-intl';
import { Api } from 'api';
import Switch from 'react-switch';


type ModalContent = {
    modalTitle: any
    modalText: any,
    confirmButtonText: any,
    confirmButtonClass: string,
    successMessage: any
}

export const PermissionRenderer = (props: PermissionRendererProps) => {
    const { vehicle } = props;
    const { licensePlate } = vehicle.localizedLicensePlate;
    const checked = vehicle.permission === 'ACTIVE_LP';

    const getModalContent = (newPermission: LicensePlatePermission, licensePlate: string): ModalContent => {
        return newPermission === 'BLOCKED_LP'
            ? {
                modalTitle: <FormattedMessage id="MODAL_LP_PERMISSION_TITLE_BLOCK" />,
                modalText: <FormattedMessage id="MODAL_LP_PERMISSION_TEXT_BLOCK" values={{ licensePlate }} />,
                confirmButtonText: <FormattedMessage id="MODAL_LP_PERMISSION_CONFIRM_BLOCK" />,
                confirmButtonClass: 'btn-red',
                successMessage: <FormattedMessage id="MODAL_LP_PERMISSION_TEXT_BLOCK_SUCCEEDED" values={{ licensePlate }} />,
            }
            : {
                modalTitle: <FormattedMessage id="MODAL_LP_PERMISSION_TITLE_ACTIVATE" />,
                modalText: <FormattedMessage id="MODAL_LP_PERMISSION_TEXT_ACTIVATE" values={{ licensePlate }} />,
                confirmButtonText: <FormattedMessage id="MODAL_LP_PERMISSION_CONFIRM_ACTIVATE" />,
                confirmButtonClass: 'btn-green',
                successMessage: <FormattedMessage id="MODAL_LP_PERMISSION_TEXT_ACTIVATE_SUCCEEDED" values={{ licensePlate }} />,
            }
    }

    const onToggle = () => {
        const newPermission = invertPermission(vehicle.permission);
        const modalContent = getModalContent(newPermission, licensePlate);

        props.updateModal(ModalEnum.CONFIRMATION_DIALOG, {
            modalTitle: modalContent.modalTitle,
            modalText: modalContent?.modalText,
            confirmButtonText: modalContent.confirmButtonText,
            confirmButtonClass: modalContent.confirmButtonClass,
            successMessage: modalContent.successMessage,
            actionOnConfirm: async () => {
                await Api.updateLicensePlatePermission(props.token, props.companyPublicId, vehicle, newPermission);
            },
            actionOnCompleted: () => {
                props.updateLicensePlatePermissionCompleted(vehicle, newPermission);
            },
            actionOnError: (error: any) => {
                console.error(error);
            },
        });
    }

    const invertPermission = (licensePlatePermission: LicensePlatePermission): LicensePlatePermission => {
        if (licensePlatePermission === 'ACTIVE_LP') {
            return LicensePlatePermission.BLOCKED_LP;
        }
        else if (licensePlatePermission === 'BLOCKED_LP') {
            return LicensePlatePermission.ACTIVE_LP;
        } else {
            return licensePlatePermission;
        }
    }

    return (
        <Switch onChange={onToggle}
            checked={checked}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor={ThemeColor.green}
            offColor={ThemeColor.red}
            height={20}
            width={50}
            handleDiameter={18}
        />
    )
}


type OwnProps = { vehicle: Vehicle };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
export type PermissionRendererProps = DispatchProps & StateProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth.token,
        companyPublicId: state.companyDetails?.companyDetails?.publicId
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow,
        updateLicensePlatePermissionCompleted: vehiclesActions.updateLicensePlatePermissionCompleted
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PermissionRenderer);